import {Injectable} from '@angular/core';
import {StorageKeys} from '../../shared/models/storage-keys';
import {LocalStorageService} from './local-storage.service';

@Injectable({
	providedIn: 'root'
})
export class AlertModalService {
	readonly failedVerificationPage = '/onboarding-v2/kyc-identity-verification-failed';
	KycLevelStorageKeys = {
		1: 'current_kyc_lvl1_step',
		2: 'current_kyc_lvl_2_step',
		3: 'current_kyc_lvl_3_step',
		4: 'current_kyc_lvl_4_step'
	}
	constructor(private localStorage: LocalStorageService) {
	}

	setRoute(route: string) {
		this.localStorage.save(StorageKeys.alert_modal_route, route);
	}

	getRoute() {
		return this.localStorage.get(StorageKeys.alert_modal_route);
	}

	setOTPSuspensionTimer(time) {
		this.localStorage.save(StorageKeys.otp_suspension_time, JSON.stringify(time));
	}

	setIdVerificationSuspensionDate(date){
		this.localStorage.save(StorageKeys.id_suspension_time, JSON.stringify(date));
	}

	getIdVerificationSuspensionDate() {
		const time = this.localStorage.get(StorageKeys.id_suspension_time);
		return time ? JSON.parse(time) : null;
	}

	getOTPSuspensionTimer() {
		const time = this.localStorage.get(StorageKeys.otp_suspension_time);
		return time ? JSON.parse(time) : null;
	}

	setModalMessage(message) {
		this.localStorage.save(StorageKeys.modal_message, message);
	}

	setStepAfterFailedModalDismissal(kycLevel: number, step: number){
	 this.localStorage.save(this.KycLevelStorageKeys[kycLevel], JSON.stringify(step));
	}

	setCallbackName(callbackName) {
		this.localStorage.save(StorageKeys.modal_callbackName, callbackName);
	}

	setModalTitle(title) {
		return this.localStorage.save(StorageKeys.modal_title, title);
	}

	getModalTitle() {
		return this.localStorage.get(StorageKeys.modal_title);
	}

	getCallbackName() {
		return this.localStorage.get(StorageKeys.modal_callbackName);
	}

	getModalMessage() {
		return this.localStorage.get(StorageKeys.modal_message);
	}

	setModalLevel(level) {
		this.localStorage.save(StorageKeys.modal_lvl, level);
	}

	getModalLevel() {
		return this.localStorage.get(StorageKeys.modal_lvl);
	}

	getOTPSuspensionTime() {
		const time = this.localStorage.get(StorageKeys.otp_suspension_time);
		return time ? JSON.parse(time) : null;
	}


	formatTime = (t) => {
		return t < 10 ? '0' + t : t;
	}


}
